// Preferencia de avisos pendentes ao entrar no painel — por usuario, no molde
// do audio.js (localStorage + listeners, sem reload).
//
// E preferencia pessoal e nao politica da organizacao: quem e interrompido e a
// pessoa, e o registro de "ja mostrei" ja e por dispositivo. O toggle de som,
// tema e layout, ao lado deste na aba Preferencias, seguem o mesmo caminho.

const CHAVE = 'lais:alertas-prefs';

export const REPETICOES = ['sessao', 'unica', 'sempre'];

export const PREFS_PADRAO = {
  ativo: true,
  repeticao: 'sessao',
  maxVisiveis: 3,
  janelaDias: 7,
};

const listeners = new Set();

function normalizar(bruto) {
  const cfg = bruto && typeof bruto === 'object' ? bruto : {};
  return {
    // `!== false` para tratar chave ausente como ligado.
    ativo: cfg.ativo !== false,
    repeticao: REPETICOES.includes(cfg.repeticao) ? cfg.repeticao : PREFS_PADRAO.repeticao,
    maxVisiveis: Number(cfg.maxVisiveis) >= 1 ? Number(cfg.maxVisiveis) : PREFS_PADRAO.maxVisiveis,
    janelaDias: Number(cfg.janelaDias) > 0 ? Number(cfg.janelaDias) : PREFS_PADRAO.janelaDias,
  };
}

export function getPrefsAlertas() {
  try {
    return normalizar(JSON.parse(localStorage.getItem(CHAVE)));
  } catch {
    return { ...PREFS_PADRAO };
  }
}

export function setPrefsAlertas(parcial) {
  const proximo = normalizar({ ...getPrefsAlertas(), ...parcial });
  try {
    localStorage.setItem(CHAVE, JSON.stringify(proximo));
  } catch (err) {
    console.debug('[notificacoes] nao foi possivel gravar alertas-prefs', err);
  }

  listeners.forEach((cb) => {
    try {
      cb(proximo);
    } catch (err) {
      console.debug('[notificacoes] listener de alertas falhou', err);
    }
  });

  return proximo;
}

export function subscribeAlertas(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
